module.exports = __webpack_public_path__ + "img/hospital-items.6bde27d1.svg";